import React from 'react';
import { Box } from '@mui/material';
import GitHubAppBar from '../Components/GithubAppBar/GithubAppBar';
import { Outlet } from 'react-router-dom';

export default function Dashboard() {
    
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', scrollbarGutter: 'stable' }}>
            <GitHubAppBar />
            <Box sx={{ mt: 'var(--toolbar-height)' }}>
                <Outlet />
            </Box>
        </Box>
    );
}